import { createSlice } from "@reduxjs/toolkit";

const initialBook = {
  name: "",
  author: "",
  publisher: "",
  pageNumber: 1,
  explanation: ""
};

const initialBooksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  book: initialBook
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const bookSlice = createSlice({
  name: "books",
  initialState: initialBooksState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getBooks
    booksFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getBook
    bookFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.book = action.payload.entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanBooksState
    booksStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.book = initialBook;
    }
  }
});